import React from 'react';
import CustomerNavbar from '../components/layout/CustomerNavbar';
import CustomerFooter from '../components/layout/CustomerFooter';
import CustomerSidebar from '../components/layout/CustomerSidebar';

function CustomerDashboard() {
  const token = localStorage.getItem('token');

  let user = null;
  if (token) {
    try {
      user = JSON.parse(atob(token));
    } catch (err) {
      console.error('❌ Failed to decode token:', token);
    }
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <CustomerNavbar />

      <div className="d-flex flex-grow-1">
        <CustomerSidebar />

        <div className="container-fluid my-4">
          <h3>📊 Welcome to Customer Dashboard</h3>
          {user ? (
            <div className="mt-3">
              <p><strong>Client User ID:</strong> {user.client_user_id}</p>
              <p><strong>Role:</strong> {user.role}</p>
              <p><strong>Customer ID:</strong> {user.customer_id}</p>
            </div>
          ) : (
            <p className="text-danger">User not logged in or token is invalid.</p>
          )}
        </div>
      </div>

      <CustomerFooter />
    </div>
  );
}

export default CustomerDashboard;
